import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  base: {},
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: indent,
    marginTop: indent * 0.5,
  },
});
